import React from 'react';
import Layout from '../../../../components/Layout/Layout';
import AnnualReportWidget from '../../../../components/Widget/AnnualReportWidget';
import AssemblyComplianceWidget from '../../../../components/Widget/AssemblyComplianceWidget';
import TestReportApprovalsWidget from '../../../../components/Widget/TestReportApprovalsWidget';
import TestStatusWidget from '../../../../components/Widget/TestStatusWidget';
import DashboardWidget from '../../../../components/Widget/DashboardWidget';
import { Box, Flex } from 'rebass';
import InitialResultByTesterWidget from '../../../../components/Widget/InitialResultByTesterWidget';

type WaterSupplierDashboardProps = Record<string, never>;

/**
 * @component Used for assemblies page
 */
function Dashboard(props: WaterSupplierDashboardProps): JSX.Element {
  return (
    <Layout>
      <Flex
        flexGrow={1}
        sx={{
          overflow: 'auto',
          padding: '20px',
        }}
        flexDirection="row"
      >
        <Box
          flexGrow={1}
          sx={{
            display: 'grid',
            gridTemplateColumns: [
              'repeat(1, 1fr)', // 1 column
              'repeat(1, 1fr)', // 1 column
              'repeat(2, 1fr)', // 2 columns
              'repeat(3, 1fr)', // 3 columns
            ],
            gridAutoRows: 'calc(50% - 10px)',
            gridGap: '20px',
          }}
        >
          <DashboardWidget
            sx={{
              gridColumn: ['span 1', 'span 1', 'span 2', 'span 2'],
            }}
            title="Assembly Test Status"
            subtitle="by Test Anniversary month"
            component={TestStatusWidget}
          />
          <DashboardWidget
            title="Test Reports"
            subtitle="Pending Review"
            component={TestReportApprovalsWidget}
          />
          <DashboardWidget
            title="Assembly Compliance"
            component={AssemblyComplianceWidget}
          />
          <DashboardWidget
            title="Annual Summary Report"
            component={AnnualReportWidget}
          />
          {/*<DashboardWidget*/}
          {/*  title="Tests Submitted"*/}
          {/*  subtitle="by Company"*/}
          {/*  component={TopCompaniesWidget}*/}
          {/*/>*/}
          <DashboardWidget
            // sx={{
            //   gridRow: 'span 2',
            // }}
            title="Tests Submitted"
            subtitle="by Company/Tester"
            component={InitialResultByTesterWidget}
          />
        </Box>
      </Flex>
    </Layout>
  );
}

export default Dashboard;
